export const formatDisplayDate = (isoDate?: string | null): string => {
    if (!isoDate) {
        return '';
    }
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
        return isoDate;
    }
    return date.toLocaleDateString();
};
